import React from 'react';

const Pricing = () => {
  const tiers = [
    {
      name: 'Starter',
      price: '$5,000',
      period: 'project',
      description: 'Perfect for small projects and MVPs',
      features: [
        '3-Month Timeline',
        'Single Technology Stack',
        'Basic SEO Optimization',
        'Email Support',
        'Post-Launch Support (30 days)',
        'Up to 2 Revisions'
      ],
      popular: false
    },
    {
      name: 'Professional',
      price: '$15,000',
      period: 'project',
      description: 'Ideal for growing businesses',
      features: [
        '4-6 Month Timeline',
        'Advanced Features & Integration',
        'Full SEO & Analytics Setup',
        'Priority Support',
        'Post-Launch Support (3 months)',
        'Unlimited Revisions',
        'Performance Optimization',
        'Security Hardening'
      ],
      popular: true
    },
    {
      name: 'Enterprise',
      price: 'Custom',
      period: 'quote',
      description: 'For complex, large-scale solutions',
      features: [
        'Custom Timeline & Scope',
        'Multi-Team Collaboration',
        'AI Integration Ready',
        'Dedicated Account Manager',
        'Extended Support (6+ months)',
        'Scalability Architecture',
        'Custom Integrations',
        'White-Label Options'
      ],
      popular: false
    }
  ];

  return (
    <section id="pricing">
      <div className="section-header">
        <h2 className="section-title">Transparent Pricing</h2>
        <p className="section-subtitle">Flexible plans designed for businesses of all sizes</p>
      </div>
      <div className="pricing-grid">
        {tiers.map((tier, index) => (
          <div className={`pricing-card ${tier.popular ? 'popular' : ''} fade-in`} key={index}>
            {tier.popular && <div className="popular-badge">Most Popular</div>}
            <h3>{tier.name}</h3>
            <div className="price">
              <span className="amount">{tier.price}</span>
              <span className="period">per {tier.period}</span>
            </div>
            <p className="tier-description">{tier.description}</p>
            <button className="glass-btn glass-btn-primary">
              <span>Get Started</span> →
            </button>
            <div className="features-list">
              {tier.features.map((feature, i) => (
                <div className="feature-check" key={i}>
                  <span className="check-icon">✓</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Pricing;
